import "./Oferta.css";
import CheckIcon from "../assets/icons/check.svg"
import Faq from "../components/FAQ";

const oferty = [
  {
    tytul: "Projekt funkcjonalny",
    lista: [
      "2–3 propozycje wnętrza + 1 poprawka",
      "Rzut funkcjonalny",
      "Moodboard i wizualizacje koncepcyjne",
    ],
  },
  {
    tytul: "Projekt standardowy",
    lista: [
      "Inwentaryzacja i analiza potrzeb",
      "2–3 propozycje wnętrza + 1 poprawka",
      "Moodboard i wizualizacje koncepcyjne",
      "Dobór materiałów, mebli i oświetlenia",
      "Szczegółowe wizualizacje 3D",
    ],
  },
  {
    tytul: "Projekt kompleksowy",
    lista: [
      "Inwentaryzacja i analiza potrzeb",
      "2–3 propozycje wnętrza + 1 poprawka",
      "Moodboard i wizualizacje koncepcyjne",
      "Dobór materiałów, mebli i oświetlenia",
      "Szczegółowe wizualizacje 3D",
      "Specyfikacja produktów i dokumentacja",
      "Nadzór autorski (wizyty na budowie)",
    ],
  },
  {
    tytul: "Projekt pojedynczego pomieszczenia",
    lista: [
      "Łazienka lub kuchnia",
      "Pokój",
      "Moodboard i wizualizacje koncepcyjne",
      "Rzut funkcjonalny",
    ],
  },
];

const Oferty = () => {
  return (
    <div className="oferta-wrapper">
      <div className="oferta-header">
        <h2>CENNIK</h2>
        <p>
          Wszystkie projekty realizuję indywidualnie, dlatego każda wycena
          dopasowywana jest do zakresu i potrzeb konkretnego Klienta.
        </p>
        <br />
        <p>Skontaktuj się ze mną, aby dostosować projekt do swoich potrzeb!</p>
      </div>
      {oferty.map((oferta, index) => (
        <div className="oferta-box" key={index}>
          <h2>{oferta.tytul}</h2>
          <ul>
            {oferta.lista.map((el, i) => (
              <li key={i}>
                <img src={CheckIcon} alt="check" className="check-icon" />
                {el}
              </li>
            ))}
          </ul>
          <h2 className="cena">{oferta.cena}</h2>
        </div>
      ))}
    </div>
  );
};

export default Oferty;
